import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Modal, { ModalProps } from 'UIKit/Modal'
import Text from 'UIKit/Text'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { StyledButton } from '../styled'

const InstructionAirdropModal: React.FC<ModalProps> = ({ onDismiss = () => {}, ...props }) => {
  return (
    <StyledModal onDismiss={onDismiss} {...props}>
      <ModalInstructionContainer>
        <Text color="#000" textAlign="center" fontSize="20px" fontWeight={600} letterSpacing="-0.4px" mb="8px">
          <Trans>HUSD Airdrop</Trans>
        </Text>
        <Box>
          <Text color="#232C3D" fontSize="12px" fontWeight={500} textAlign="center" lineHeight="14.63px" mb="12px">
            <Trans>
              When you bet, you open up the opportunity to receive an airdrop from HunnyPlay. The more you bet, the
              higher your chance of getting one.
            </Trans>
          </Text>
          <Box>
            <Flex>
              <Flex minWidth={100} height={100} alignItems="center" justifyContent="center">
                <Image src="/images/airdrop/image-instruction.png" width={100} height={100} />
              </Flex>
              <StyledText>
                <Trans>Catch the gift when it dropping</Trans>
              </StyledText>
            </Flex>
            <Flex>
              <Flex minWidth={100} maxWidth={100}>
                <Image src="/images/airdrop/image-instruction1.png" width={100} height={100} />
              </Flex>
              <StyledText>
                <Trans>Or claim all the gifts we've helped you store in the bottom bar</Trans>
              </StyledText>
            </Flex>
            <Flex>
              <Flex minWidth={100} maxWidth={100}>
                <Image src="/images/airdrop/image-instruction2.png" width={100} height={100} />
              </Flex>
              <StyledText>
                <Trans>The gift may include HUSD, special bonuses, or nothing</Trans>
              </StyledText>
            </Flex>
          </Box>
        </Box>
        <StyledButton
          fontSize={['14px', '', '12px']}
          primary
          width="100%"
          onClick={async () => {
            onDismiss()
          }}
        >
          <Text bold fontSize="14px">
            <Trans>Got it</Trans>
          </Text>
        </StyledButton>
      </ModalInstructionContainer>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  padding: 20px;
  width: 280px !important;
  min-width: 280px !important;
  background: radial-gradient(150.52% 137.62% at 0% 0%, #fff 0%, #fee9ed 100%);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: top;
`

const StyledText = styled(Text)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 4px;
  color: #1d2533;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.24px;
`

const ModalInstructionContainer = styled(Box)`
  display: block;
  margin: 0 auto;
`

export default InstructionAirdropModal
